import React from "react";
import { isAuthenticated } from "../model/Functions";
import { Navigate } from "react-router-dom";
import { AppRoutes } from "../navigation/AppRoutes";
export function PrivateRoute({ children }: { children: React.ReactNode }) {
  return isAuthenticated() ? <>{children}</> : <Navigate to={AppRoutes.ROOT} replace />;
}
